/**
 * Static redirect rules (fallback alongside DB-driven redirects).
 */
export interface RedirectRule {
  from: string;
  to: string;
  isPrefix?: boolean;
}

export const redirectRules: RedirectRule[] = [
  { from: '/leistungen/shop-entwicklung', to: '/leistungen/onlineshop-entwicklung' },
  { from: '/en/services/shop-development', to: '/en/services/ecommerce-development' },
];

export function findRedirect(path: string): string | null {
  const normalizedPath = path === '/' ? '/' : path.replace(/\/$/, '');
  for (const rule of redirectRules) {
    if (rule.isPrefix) {
      if (normalizedPath.startsWith(rule.from)) {
        return rule.to + normalizedPath.slice(rule.from.length);
      }
    } else {
      if (normalizedPath === rule.from || normalizedPath === rule.from.replace(/\/$/, '')) {
        return rule.to;
      }
    }
  }
  return null;
}
